import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Divider from "@mui/material/Divider";
import { useCompact } from "../../../utils/hooks/useCompact";

export default function ChartWithSummarySkeleton() {
  const isCompact = useCompact();

  return (
    <Paper sx={{ p: 2 }}>
      <Skeleton variant="text" width={160} height={24} sx={{ mb: 1 }} />
      <Skeleton variant="rectangular" width={200} height={32} sx={{ mb: 1 }} />
      <Skeleton variant="rectangular" width={80} height={28} sx={{ mb: 3 }} />
      <Divider sx={{ mb: 3 }} />
      <Skeleton variant="rectangular" width="100%" height={isCompact ? 220 : 260} />
    </Paper>
  );
}
